<template>
  <div>
    <Navigation />
    <section class="section__container top__container center__text">
      <h1 class="title center__text">PLATEFORME D’ENVOI SMS PAR MÉTIERS</h1>

      <h2>
        Lancez vos campagnes sans tracas en utilisant ces modèles de SMS
      </h2>

      <div class="model__card seventy__container">
        <div class="card">
          <img class="card__image" src="/../images/teach-80x80.png" alt="" />
          <router-link to="/parent" class="card__description">SMS éducatifs pour enseignement</router-link>
        </div>
        <div class="card">
          <img class="card__image" src="/../images/group-80x80.png" alt="" />
          
          <router-link to="/association" class="card__description">SMS pros pour associations</router-link>
        </div>
        <div class="card">
          <img
            class="card__image"
            src="/../images/icone_transport-logistique.png"
            alt=""
          />
         
          <router-link to="/logistique" class="card__description">SMS logistique et transport</router-link>
        </div>
        <div class="card">
          <img class="card__image" src="/../images/boutique.png" alt="" />
          <router-link to="/commerce" class="card__description">SMS pour commerces locaux</router-link>
        </div>
        <div class="card">
          <img class="card__image" src="/../images/marketing.png" alt="" />
          <router-link to="/marketing" class="card__description">SMS promotionnels, communication</router-link>
        </div>

        
        <div class="card">
          <img class="card__image" src="/../images/cafe.png" alt="" />
          <router-link to="/cafe" class="card__description">SMS hôtellerie et restauration</router-link>
        </div>

        <div class="card">
          <img class="card__image" src="/../images/local.png" alt="" />
       
           <router-link class="card__description" to="/collective"> SMS pour gouvernance locale</router-link>
          
        </div>
        <div class="card">
          <img class="card__image" src="/../images/car.png" alt="" />
          <router-link to="/automobile" class="card__description">SMS experts auto professionnels</router-link>
        </div>
        <div class="card">
          <img class="card__image" src="/../images/sante.png" alt="" />
          
          <router-link to="/profession" class="card__description">Professionnels de santé / Hôpitaux</router-link>
        </div>

        <div class="card">
          <img class="card__image" src="/../images/tourist.png" alt="" />
          <router-link to="/Tourism" class="card__description">SMS voyage, tourisme</router-link>
        </div>
        <div class="card">
          <img class="card__image" src="/../images/recruit.png" alt="" />
          <router-link to="/agency" class="card__description">SMS emploi, recrutement</router-link>
        </div>
         <div class="card">
          <img class="card__image" src="/../images/immoble.png" alt="" />
          
          <router-link to="/immoble" class="card__description">SMS immobilier pour vente</router-link>
        </div>
        
         <div class="card">
          <img class="card__image" src="/../images/vote.png" alt="" />
        
          <router-link to="/parti" class="card__description">SMS campagne politique</router-link>
        </div>
         <div class="card">
          <img class="card__image" src="/../images/environment.png" alt="" />
         
          <router-link to="/environmental" class="card__description">SMS événements spéciaux</router-link>
        </div>
        
         <div class="card">
          <img class="card__image" src="/../images/porter.png" alt="" />
          
          <router-link to="/porter" class="card__description">SMS vêtements, mode</router-link>
        </div>
      </div>
    </section>
    <Revolution/>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Revolution from './Revolution';
import Footer from './Footer';
export default {
  components: {
    Navigation,
    Revolution,
    Footer
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.card {
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  margin-top: 2rem;
  transition: transform .3s;

  &:hover{
    transform: scale(1.1); 
  }
}
.card__description{
     border-bottom: 4px solid $color-tertiary;
     border-width: 10px;
     text-align: center;
     font-weight: bolder;
     display:inline-block;
     text-decoration: none;
     color: #000;
}
@media (min-width: 64rem) {
 
  .model__card{
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 2rem;
      
  }

 .top__container{
  margin-top:10rem;
 }
  .last__card{
      margin-bottom: 2rem;

  }
}
</style>
